// Left to Free Shipping Function
(function() {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const cartValueAnnounce = document.querySelector('#cart_value_announce');
      if (!cartValueAnnounce) return;

      if (window.AfterShipPersonalization?.Cart) { 
        const cart = window.AfterShipPersonalization?.Cart;
        total_price = cart?.data.total_price
        let html = `You're so close to 15% off + free express shipping—just $${100 - (total_price / 100)} to go!`;
        cartValueAnnounce.querySelector('.announcement__text').innerHTML = html;
      }
    }, 350);
  })
})();